import getProductName from "@helpers/products/getProductName";

import type { Product } from "@typings/product/product";
import type { GACartItem } from "@typings/analytics/google";

export const transformCartItemsToGA = (cartItems: Product[]): GACartItem[] => {
  return cartItems.map((cartItem, index) => {
    const { item, configuration } = cartItem;

    return {
      index,
      item_id: item.id,
      item_name: getProductName(cartItem),
      item_category: item.category.name,
      item_category2: configuration.offer.name,
      price: configuration.price,
      quantity: configuration.price,
      currency: "USD",
    };
  });
};
